module.exports = __webpack_public_path__ + "img/twitter.67de9964.svg";